import React, { useState } from "react";
import { CloseIcon } from "../Auth/onboarding/icons";
import { ChevronDownIcon, UsersIcon } from "../Dashboard/icons";
import { PlusIcon } from "../InstallSettings/icons";

const roles = ["Owner", "Admin", "Editor", "Viewer"];

const initialMembers = [
  {
    id: "am",
    name: "Ariun Mehta",
    email: "admin@gopointr.com",
    role: "Owner",
    status: "Active",
    lastActive: "Online now",
  },
  {
    id: "ps",
    name: "Priya Sharma",
    email: "priya@gopointr.com",
    role: "Admin",
    status: "Active",
    lastActive: "2 hours ago",
  },
  {
    id: "dk",
    name: "Dev Kapoor",
    email: "dev@gopointr.com",
    role: "Editor",
    status: "Active",
    lastActive: "Yesterday",
  },
  {
    id: "rn",
    name: "rhea@gopointr.com",
    email: "Invited 2 days ago",
    role: "Viewer",
    status: "Pending",
    lastActive: "—",
  },
];

export default function TeamPanel() {
  const [members, setMembers] = useState(initialMembers);
  const [inviting, setInviting] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteRole, setInviteRole] = useState("Editor");

  const seatsUsed = members.filter((m) => m.status === "Active").length;

  const handleInvite = (e) => {
    e.preventDefault();
    const email = inviteEmail.trim();
    if (!email) return;

    setMembers((prev) => [
      ...prev,
      {
        id: email,
        name: email,
        email: "Invited just now",
        role: inviteRole,
        status: "Pending",
        lastActive: "—",
      },
    ]);
    setInviteEmail("");
    setInviting(false);
  };

  const updateRole = (id, role) => {
    setMembers((prev) => prev.map((m) => (m.id === id ? { ...m, role } : m)));
  };

  const removeMember = (id) => {
    setMembers((prev) => prev.filter((m) => m.id !== id));
  };

  return (
    <section className="dash-card">
      <div className="acct-panel-head">
        <div>
          <h2 className="cz-card-title">Team members</h2>
          <p className="ist-card-subtitle acct-panel-sub">
            {seatsUsed} of 10 seats used on your Business plan.
          </p>
        </div>
        <button
          type="button"
          className="acct-btn acct-btn--primary"
          onClick={() => setInviting((v) => !v)}
        >
          <PlusIcon />
          Invite member
        </button>
      </div>

      {inviting && (
        <form className="acct-invite" onSubmit={handleInvite}>
          <input
            type="email"
            className="review-input"
            placeholder="teammate@company.com"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            autoFocus
          />
          <div className="cz-select-wrap acct-invite__role">
            <select value={inviteRole} onChange={(e) => setInviteRole(e.target.value)}>
              {roles
                .filter((role) => role !== "Owner")
                .map((role) => (
                  <option key={role}>{role}</option>
                ))}
            </select>
            <ChevronDownIcon />
          </div>
          <button type="submit" className="acct-btn acct-btn--primary">
            Send invite
          </button>
        </form>
      )}

      <div className="acct-table-wrap">
        <table className="acct-table">
          <thead>
            <tr>
              <th>Member</th>
              <th>Role</th>
              <th>Status</th>
              <th>Last active</th>
              <th aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {members.map((member) => (
              <tr key={member.id}>
                <td>
                  <div className="acct-member">
                    <span className="acct-member__avatar">
                      {member.name.charAt(0).toUpperCase()}
                    </span>
                    <div>
                      <strong>{member.name}</strong>
                      <span>{member.email}</span>
                    </div>
                  </div>
                </td>
                <td>
                  {member.role === "Owner" ? (
                    <span className="acct-role-static">Owner</span>
                  ) : (
                    <div className="cz-select-wrap acct-role-select">
                      <select
                        value={member.role}
                        onChange={(e) => updateRole(member.id, e.target.value)}
                        aria-label={`Role for ${member.name}`}
                      >
                        {roles
                          .filter((role) => role !== "Owner")
                          .map((role) => (
                            <option key={role}>{role}</option>
                          ))}
                      </select>
                      <ChevronDownIcon />
                    </div>
                  )}
                </td>
                <td>
                  <span
                    className={`bill-badge ${
                      member.status === "Active" ? "bill-badge--active" : "bill-badge--pending"
                    }`}
                  >
                    {member.status}
                  </span>
                </td>
                <td className="acct-table__muted">{member.lastActive}</td>
                <td className="acct-table__actions">
                  {member.role !== "Owner" && (
                    <button
                      type="button"
                      className="acct-icon-btn"
                      aria-label={`Remove ${member.name}`}
                      onClick={() => removeMember(member.id)}
                    >
                      <CloseIcon />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="acct-note">
        <UsersIcon />
        Need more seats? Extra seats are $9 / month each and can be added from Billing.
      </p>
    </section>
  );
}
